// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAZTwRtg7t_S5jXK1O_YdOpjlz34R5A57w",
  authDomain: "lilable-66c95.firebaseapp.com",
  projectId: "lilable-66c95",
  storageBucket: "lilable-66c95.firebasestorage.app",
  messagingSenderId: "1077565120756",
  appId: "1:1077565120756:web:1757505b7b154604803ea1",
  measurementId: "G-32TYZF48GJ"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
